module.exports = __webpack_public_path__ + "static/media/footer_5.91a1f415.png";